module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.7deb530.eot";